import { Mode } from './Mode.js';
import { QRData } from './QRData.js';
/**
 * QRNumber
 *
 * @author Kazuhiko Arase
 */
export class QRNumber extends QRData {
    constructor(data) {
        super(Mode.MODE_NUMBER, data);
    }
    write(buffer) {
        const data = this.getData();
        let i = 0;
        while (i + 2 < data.length) {
            buffer.put(QRNumber.strToNum(data.substring(i, i + 3)), 10);
            i += 3;
        }
        if (i < data.length) {
            if (data.length - i == 1) {
                buffer.put(QRNumber.strToNum(data.substring(i, i + 1)), 4);
            }
            else if (data.length - i == 2) {
                buffer.put(QRNumber.strToNum(data.substring(i, i + 2)), 7);
            }
        }
    }
    getLength() {
        return this.getData().length;
    }
    static strToNum(s) {
        let num = 0;
        for (let i = 0; i < s.length; i += 1) {
            num = num * 10 + QRNumber.chatToNum(s.charAt(i));
        }
        return num;
    }
    static chatToNum(c) {
        if ('0' <= c && c <= '9') {
            return c.charCodeAt(0) - '0'.charCodeAt(0);
        }
        throw new Error('illegal char :' + c);
    }
}
//# sourceMappingURL=QRNumber.js.map